import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarCentrosDeCostoPaginado,
  listarCuentasContablesPaginado,
  type ListarCatalogoContableParams,
} from "../services/catalogos-contables-admin-service";

/**
 * Listados PAGINADOS del gestor admin de catálogos contables. Hooks separados
 * de los del wizard (`useCecos`/`useCuentas` en features/catalogos · flat, sin
 * params) para no tocar a los pickers de prorrateo. Las keys extienden
 * qk.cecos / qk.cuentas: los invalidate de las mutations alcanzan a ambas
 * variantes por prefijo.
 */
export const cecosAdminQueryOptions = (params: ListarCatalogoContableParams = {}) =>
  queryOptions({
    queryKey: [...qk.cecos, "admin", params] as const,
    queryFn: () => listarCentrosDeCostoPaginado(params),
    placeholderData: keepPreviousData,
  });

export const cuentasAdminQueryOptions = (params: ListarCatalogoContableParams = {}) =>
  queryOptions({
    queryKey: [...qk.cuentas, "admin", params] as const,
    queryFn: () => listarCuentasContablesPaginado(params),
    placeholderData: keepPreviousData,
  });

export const useCecosAdmin = (params: ListarCatalogoContableParams = {}) =>
  useQuery(cecosAdminQueryOptions(params));

export const useCuentasAdmin = (params: ListarCatalogoContableParams = {}) =>
  useQuery(cuentasAdminQueryOptions(params));
